<template>
    <div class="content md">
        <system-admin type="asset"></system-admin>
    </div>
</template>

<script>
    import SystemAdmin from "../../layouts/SystemAdmin";
    export default {
        name: "AssetAuth",
        components: {
            SystemAdmin
        }
    }
</script>

<style scoped>

</style>